import { useMemo } from 'react';
import { useScenarioContext } from '@/shared/providers';
import useQuery from '@pkg/api/useQuery';
import toPriorityQuadrant from '../utils/toPriorityQuadrant';

const FALLBACK = 'Unfortunately, we could not make a suggestion';

/**
 * Advice on the activities that are neither important nor energising.
 *
 * The quadrant is derived here and sent whole: the view has already computed it
 * to draw the chart, and the service reasons over what it is given rather than
 * reading the design for itself.
 *
 * @param {Boolean} enabled
 * @returns {Object}
 */
export default function useSuggestion(enabled) {
  const { scenario } = useScenarioContext();

  const quadrant = useMemo(() => toPriorityQuadrant(scenario), [scenario]);

  const { suggestion, refetch, isLoading, isFetching, remove } = useQuery(
    [
      'suggest-priority',
      scenario?.details?.designId,
      scenario?.entity?.uuid,
      scenario?.details?.hash,
    ],
    function fetcher() {
      return this.post('v1/suggest/priority', quadrant);
    },
    {
      dataKey: 'suggestion',
      dataHandler: (result) => result.data?.data || FALLBACK,
      enabled: Boolean(enabled && quadrant),
      retry: false,
      refetchOnWindowFocus: false,
    }
  );

  return {
    suggestion,
    refetch,
    isLoading,
    isFetching,
    remove,
  };
}
